/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import PlusIcon from "../../assets/Icons/PlusIcon.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  CREATE_NEGOTIATION,
  GET_PROFILE_DETAILS,
} from "../../redux/Action/actionTypes";
import OverviewPage from "./Overview/OverviewPage";
import ToastNotifier from "../../components/ToastNotifier/toastNotifier";
import { Spinner } from "reactstrap";
import { RootState } from "../../redux/Reducer";
import { resetDraftNavigation } from "../../redux/Action/Action";

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isNavigate = useSelector(
    (state: RootState) => state.dashboardData.isNavigate
  );
  const isLoader = useSelector(
    (state: RootState) => state.toastMessageReducer.loading
  );
  const contractStatus = useSelector(
    (state: RootState) => state.dashboardData.contractStatus
  );

  // profile method api call once user lands on overview page 
  useEffect(() => {
    dispatch({
      type: GET_PROFILE_DETAILS,
    });
  }, [dispatch]);

  // Add new button method call after clicking on add new button 
  const handleAddNewClick = () => {
    dispatch({
      type: CREATE_NEGOTIATION,
      payload: { state: false, ID: null }, // CREATE or UPDATE
    });
    navigate("/negotiationForm");
  };

  // navigating the application for all flows 
  useEffect(() => {
    if (isNavigate) {
      if (contractStatus === "draft") {
        navigate("/negotiationForm");
      } else if (contractStatus === "inProgress"){
        navigate("/detailedOverview");
      }else if(contractStatus === "completed"){
        navigate('/closeNegotiation')
      }else if(contractStatus === "inReview"){
        navigate('/DocumentOutcome')
      }
      dispatch(resetDraftNavigation());
    }
  }, [isNavigate]);

  return (
    <div>
      <div className="dashboard-container">
        <button className="add-new-btn" onClick={handleAddNewClick}>
          <img src={PlusIcon} alt="Plus Icon" />
          <span>Add New</span>
        </button>

        <OverviewPage />
      </div>
      <ToastNotifier />
      {isLoader && (
        <div className="spinner-overlay">
          <Spinner className="spinner-style"></Spinner>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
